import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ClientEnvironment, ConfigObjectModel, ENVIRONMENT, anyAsset } from '@thehubz/client/core';
import { Collection, CollectionsApiService } from '@thehubz/client/data-access-api';
import { CustomClients } from '@thehubz/shared/branding';
import { AssetCommonService } from '../../../../../services/asset-common.service';

@Component({
  selector: 'thehubz-collection-card-view-actions',
  templateUrl: './collection-card-view-actions.component.html',
  styleUrls: ['./collection-card-view-actions.component.scss'],
})
export class CollectionCardViewActionsComponent implements OnInit {
  @Input() configObject!: ConfigObjectModel;
  @Input() assetDetails = '';
  @Input() collection!: Collection;
  @Output() editCollection = new EventEmitter<string>();
  @Output() downloadCollection = new EventEmitter<string>();
  @Output() publishCollection = new EventEmitter<string>();
  @Output() unpublishCollection = new EventEmitter<string>();
  @Output() shareCollection = new EventEmitter<string>();
  @Output() deleteCollection = new EventEmitter<string>();
  AnyAsset = anyAsset;
  collectionOwner = false;
  collectionPublished = false;
  brandingKey: CustomClients;
  CustomClients = CustomClients;
  @ViewChild('taskMenuTrigger') trigger!: MatMenuTrigger;

  constructor(
    @Inject(ENVIRONMENT) readonly env: ClientEnvironment,
    private assetCommonService: AssetCommonService,
    private collectionAPIService: CollectionsApiService,
  ) {
    this.brandingKey = this.env.brandingKey;
  }

  ngOnInit(): void {
    if (this.collection.published && this.collection.published.length > 0) {
      this.collectionPublished = true;
    }
    this.collectionOwner = this.assetCommonService.checkCollectionOwner(this.collection);
  }

  openMenu() {
    this.collectionAPIService
      .collectionsControllerFindOne(this.collection._id, JSON.stringify({ projection: { published: 1 } }))
      .subscribe(async (resp: Collection) => {
        if (resp.published && resp.published.length > 0) {
          this.collectionPublished = true;
        } else {
          this.collectionPublished = false;
        }
        this.trigger.openMenu();
      });
  }
}
